module.exports = __webpack_public_path__ + "static/media/lspire.8b4dc9d4.PNG";